<template>
  <div>
    <div class="" v-for="(v, i) in orderDetails" :key="i">
      <!-- <div>
        {{v.ProductName}}
      </div> -->
      <gLine></gLine>
      <gTitle :t="v.ProductName"></gTitle>
      <van-field center clearable label="退款数量">
        <template #button>
          <!-- <div class="add-r c-f-bt">
            <div @click="goodsNumHandler('delete')">
              <g-img
                :src="require('@/assets/images/reduce_icon.png')"
                :size="50"
              ></g-img>
            </div>
            <div class="c">
              {{backNum}}
            </div>
            <div @click="goodsNumHandler('add')">
              <g-img
                :src="require('@/assets/images/add_icon_active.png')"
                :size="50"
              ></g-img>
            </div>
          </div> -->
          <van-stepper
            :value="v.Quantity"
            theme="round"
            button-size="22"
            min="0"
            disable-input
            :show-minus="v.Quantity > 0"
            :disable-plus="v.Quantity >= v.MaxQuantity"
            :disable-minus="v.Quantity <= 1"
            @plus="goodsNumHandler('add', v)"
            @minus="goodsNumHandler('minus', v)"
          />
          <!-- <gHandleNumber :num.sync="v.Quantity"></gHandleNumber> -->
        </template>
      </van-field>
      <!-- <div class="c-f-bt">
        <div>退款数量</div>
        <div class="add-r c-f-bt">
          <div @click="goodsNumHandler('delete')">
            <g-img
              :src="require('@/assets/images/reduce_icon.png')"
              :size="50"
            ></g-img>
          </div>
          <div class="c">
            {{backNum}}
          </div>
          <div @click="goodsNumHandler('add')">
            <g-img
              :src="require('@/assets/images/add_icon_active.png')"
              :size="50"
            ></g-img>
          </div>
        </div>
      </div> -->

      <van-cell-group>
        <van-cell title="退款金额" :value="v.SettlePrice * v.Quantity" />
      </van-cell-group>
      <div>
        <van-field
          required
          v-model="reason"
          rows="1"
          autosize
          label="退款原因"
          type="textarea"
          placeholder="请输入退款原因"
          show-word-limit
        />
      </div>

      <gBottomBtn t="申请退款" @click="applyDrawback"></gBottomBtn>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApplyDrawback",
  props: {},
  data() {
    return {
      backNum: 1,
      orderDetails: [],
      reason: "",
    };
  },
  components: {},
  created() {
    let res = $store.state;
  },
  mounted() {
    const orderDetailsList = this.$store.state.orderDetails;
    const preOrderList = orderDetailsList.map((item) => {
      return {
        ...item,
        MaxQuantity: item.Quantity,
      };
    });
    this.orderDetails = preOrderList;
  },
  methods: {
    applyDrawback() {
      const { orderDetails } = this;
      //   let items = orderDetails.filter(v => {
      //     if ('Id' in v || 'Quantity' in v) {
      //       return true
      //     } else {
      //       return false
      //     }
      //   })
      let items = orderDetails.map((v) => {
        let obj = {};
        if ("Id" in v) {
          obj.OrderDetailId = v.Id;
        }
        obj.Quantity = v.Quantity;
        return obj;
      });
      let params = {
        OrderId: orderDetails[0].OrderId,
        Reason: this.reason,
        Items: items,
      };
      if (!this.reason.trim()) {
        return this.$toast("请输入退款原因");
      }
      $http("wechath5/zh-cn/v1/refund", params, "put").then((res) => {
        this.$toast("申请退款成功");
        this.$router.replace({
          path: "/goods/orderDetail",
          query: { id: orderDetails[0].OrderId },
        });
      });
    },
    goodsNumHandler(handle, item) {
      if (handle === "add") {
        item.Quantity++;
      } else {
        item.Quantity--;
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>
